module.exports = __webpack_public_path__ + "img/thumb_Atelier_2.634c5eb5.jpg";